import React, { useCallback } from 'react'
import styled from 'styled-components'
import { Text, Toggle } from '@pancakeswap-libs/uikit'
import { useUserDisableMultihop } from 'state/user/hooks'
import useI18n from 'hooks/useI18n'
import QuestionHelper from '../QuestionHelper'

const StyledDisableMultihopSetting = styled.div`
  margin-bottom: 16px;
`

const Label = styled.div`
  align-items: center;
  display: flex;
`

const ToggleWrapper = styled.div`
  margin-left: auto;
`

const DisableMultihopSetting = () => {
  const TranslateString = useI18n()
  const [disableMultihop, setDisableMultihop] = useUserDisableMultihop()

  const handleToggle = useCallback(() => {
    setDisableMultihop(!disableMultihop)
  }, [disableMultihop, setDisableMultihop])

  return (
    <StyledDisableMultihopSetting>
      <Label>
        <Text style={{ fontWeight: 600 }} mr="8px">
          {TranslateString(9990, 'Disable Multihop')}
        </Text>
        <QuestionHelper
          text={TranslateString(9991, 'Restricts swaps to direct pairs only. Routes through intermediary tokens will not be used.')}
        />
        <ToggleWrapper>
          <Toggle
            id="disable-multihop-toggle"
            checked={disableMultihop}
            onChange={handleToggle}
            scale="md"
            aria-label={TranslateString(9992, 'Toggle disable multihop')}
          />
        </ToggleWrapper>
      </Label>
    </StyledDisableMultihopSetting>
  )
}

export default DisableMultihopSetting
